import { Button, Typography } from '@mui/material';
import DarkBackgroundImage from 'assets/home/background-banner-target-audience-dark.png';
import LightBackgroundImage from 'assets/home/background-banner-target-audience-light.png';
import { BANNER_BREAKING_POINT, BANNER_HIDE_BREAKING_POINT } from 'pages/brand-hub/BannerLayout';
import { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import gtmIds from 'services/tracking/GTMIds';
import { withGtmInteraction } from 'services/tracking/withGtmInteraction';
import styled from 'styled-components';
import useTr from 'utils/hooks/useTr';

export const TargetAudienceBanner = () => {
  const translate = useTr();

  const handleBannerClick = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    window.open(translate('home.banner.targetAudience.redirect_link'), '_blank');
  };

  return (
    <Root
      onClick={handleBannerClick}
      {...withGtmInteraction(gtmIds.home.targetAudienceBanner)}
    >
      <ContentContainer>
        <FormattedMessage
          id="home.banner.targetAudience.title"
          values={{
            br: <br />,
            highlight: (chunks: string) => <Highlight>{chunks}</Highlight>
          }}
        />
      </ContentContainer>

      <StyledButton variant="contained" size="small">
        <FormattedMessage id="home.banner.targetAudience.button" />
      </StyledButton>
    </Root>
  );
};

const Highlight = styled.span`
  ${({ theme }) => ({
    ...theme.typography.h3,
    color: theme.colors.commonWhiteMain
  })}
`;

const StyledButton = styled(Button)`
  position: absolute;
  bottom: 8px;
  right: 18px;

  background-color: ${({ theme }) => theme.colors.commonWhiteMain};
  color: ${({ theme }) => theme.colors.commonBlackMain};

  &:hover {
    background-color: ${({ theme }) => theme.colors.commonWhiteMain};
  }
`;

const Root = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.one};
  background-image: ${({ theme }) =>
    `url(${theme.mode === 'dark' ? DarkBackgroundImage : LightBackgroundImage})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 176px;
  /* Unusual margin is used here to let this banner take up a total of 200px vertical space */
  margin: 12px 0;
  cursor: pointer;

  @media (max-width: ${BANNER_BREAKING_POINT}px) {
    gap: ${({ theme }) => theme.spacings.one};
  }

  @media (max-width: ${BANNER_HIDE_BREAKING_POINT}px) {
    display: none;
  }
`;

const ContentContainer = styled(Typography).attrs({
  variant: 'h4',
  color: 'white'
})`
  text-align: center;
  font-style: normal;
  font-weight: 400;
  max-width: 240px;

  @media (max-width: ${BANNER_BREAKING_POINT}px) {
    ${({ theme }) => ({
      ...theme.typography.h5
    })}
  }
`;
